import React, {useState} from 'react';
import {observer} from "mobx-react-lite";
import {Badge, Card, Col, Divider, Modal, Rate, Row, Tag} from "antd";
import dayjs from "dayjs";
import ReviewOne from "../reviewOne/reviewOne";
import QueOne from "../QueOne/QueOne";

const Que2025 = observer((props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            {(props.dta.ques_count>0)?(
                <>
                    {/*<Tag onClick={showModal} color="volcano">{props.dta.questext}</Tag>*/}
                    <Tag
                        color="volcano"
                        onClick={showModal}
                        style={{
                            width: '100%',
                            color: 'black',
                            textAlign: 'center',      // Центрирование текста
                            display: 'block',          // Обязательно для корректного выравнивания в 100% ширины
                            cursor: 'pointer'
                        }}
                    >
                        {props.dta.questext}
                    </Tag>

                    <Modal   width={1600} title="В" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                            <QueOne dta={props.dta} />


                    </Modal>

                </>
            ):(
                <></>
            )}



        </>
    );
})

export default Que2025;